import { postDataAPI } from "../../../helper/api";
import { submit_hubspot_form } from '../../../helper/hubspotApi'


export const requestLogin = payload => {
	return postDataAPI("/api/Auth/ExplorerLoginRequest", { ...payload });
};

export const requestVerifyCode = payload => {
	return postDataAPI("/api/Auth/VerifyCode", { ...payload });
};

export const requestCreateUser = payload => {
	const response = submit_hubspot_form(payload);
    return postDataAPI("/api/Account/ExplorerUser", { ...payload });
}